import React, { useState } from "react";
import apiService from "../../services/api";
import { useNavigate } from "react-router-dom";
import "./styles/detials.css";

export default function CreateRestaurant() {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    restaurantName: "",
    ownerName: "",
    ownerPhone: "",
    ownerEmail: "",
    restaurantAddress: "",
    phone: "",
    email: "",
    description: "",
    openingTime: "",
    closingTime: "",
    category: "",
    city: "",
    state: "",
    pincode: "",
    logo: null,
  });

  /*
  ==========================
  HANDLE INPUT CHANGE
  ==========================
  */

  const handleChange = (e) => {

    const { name, value, files } = e.target;

    if (files) {

      setForm({
        ...form,
        [name]: files[0],
      });

    } else {

      setForm({
        ...form,
        [name]: value,
      });

    }

  };

  /*
  ==========================
  VALIDATION
  ==========================
  */

  const validateForm = () => {

    if (!form.restaurantName)
      return "Restaurant name required";

    if (!form.ownerName)
      return "Owner name required";

    if (!form.ownerPhone)
      return "Owner phone required";

    return null;

  };

  /*
  ==========================
  SUBMIT
  ==========================
  */

  const handleSubmit = async () => {

    try {

      const error = validateForm();

      if (error) {
        alert(error);
        return;
      }

      setLoading(true);

      const formData = new FormData();

      Object.keys(form).forEach((key) => {
        formData.append(key, form[key]);
      });

      /*
      TOKEN
      */

      const token =
        localStorage.getItem("token");

      const response =
        await apiService.createRestaurant(
          formData,
          token
        );

      console.log(response);

      alert(
        "Restaurant created successfully 🎉"
      );

      navigate("/admin/restaurants");

    } catch (error) {

      console.error(error);

      alert(
        error?.response?.data?.message ||
        "Failed to create restaurant"
      );

    } finally {

      setLoading(false);

    }

  };

  /*
  ==========================
  UI
  ==========================
  */

  return (
    <div className="section">

      <div className="container2">

        <h2>
          🍽️ Create New Restaurant
        </h2>

        <div className="add-form">

          <input
            name="restaurantName"
            placeholder="Restaurant Name"
            className="form-input"
            onChange={handleChange}
          />

          <input
            name="ownerName"
            placeholder="Owner Name"
            className="form-input"
            onChange={handleChange}
          />

          <input
            name="ownerPhone"
            placeholder="Owner Phone"
            className="form-input"
            onChange={handleChange}
          />

          <input
            name="ownerEmail"
            placeholder="Owner Email"
            className="form-input"
            onChange={handleChange}
          />

          <textarea
            name="restaurantAddress"
            placeholder="Restaurant Address"
            className="form-input"
            onChange={handleChange}
          />

          <input
            name="phone"
            placeholder="Restaurant Phone"
            className="form-input"
            onChange={handleChange}
          />

          <input
            name="email"
            placeholder="Restaurant Email"
            className="form-input"
            onChange={handleChange}
          />

          <textarea
            name="description"
            placeholder="Description"
            className="form-input"
            onChange={handleChange}
          />

          <div className="time-row">

            <input
              type="time"
              name="openingTime"
              className="form-input"
              onChange={handleChange}
            />

            <input
              type="time"
              name="closingTime"
              className="form-input"
              onChange={handleChange}
            />

          </div>

          <select
            name="category"
            className="form-input"
            onChange={handleChange}
          >
            <option value="">
              Select Category
            </option>

            <option value="Veg">
              Veg
            </option>

            <option value="Non-Veg">
              Non-Veg
            </option>

            <option value="Cafe">
              Cafe
            </option>

            <option value="Fast Food">
              Fast Food
            </option>

          </select>

          <input
            name="city"
            placeholder="City"
            className="form-input"
            onChange={handleChange}
          />

          <input
            name="state"
            placeholder="State"
            className="form-input"
            onChange={handleChange}
          />

          <input
            name="pincode"
            placeholder="Pincode"
            className="form-input"
            onChange={handleChange}
          />

          <label>
            Upload Restaurant Logo
          </label>

          <input
            type="file"
            name="logo"
            accept="image/*"
            className="form-input"
            onChange={handleChange}
          />

          <div className="form-buttons">

            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >

              {loading
                ? "Creating..."
                : "Create Restaurant"}

            </button>

            <button
              className="btn btn-secondary"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

          </div>

        </div>

      </div>

    </div>
  );

}